export default __webpack_public_path__ + "static/feature-importances-long-e5127aa8ac78888679106782c2fb6ffc.png";